
import request      from '../dom/modules/request.js';
import headers      from '../modules/headers.js';
import { Observer } from '../literal/module.js';

const config = window.config;

const collections = [];
const assign = Object.assign;

function update(response) {
    response.user_collections && response.user_collections.forEach((col) => {
        let collection = collections.find((collection) => collection.pk === col.pk);

        if (!collection) {
            collection = col;
            Observer(collections).push(collection);
            //console.log('ADDED COLLECTION', collections.length);
        }
        else {
            assign(Observer(collection), col);
        }
    });

    return collections;
}

export function requestPostCollections(data) {
    return request('post', config.collectionsURL, data, headers)
    .then(update);
}

export default collections;

// Update initial state of collections
request('get', config.collectionsURL, null, headers)
.then(update);
